import classNames from 'classnames';
import * as React from 'react';
import { Accordion, AccordionItem, AccordionItemBody, AccordionItemTitle } from 'react-accessible-accordion';

import { Bem } from '../../service/Bem/Bem';
import { Shape2, Shape2Icon, Shape2Tone } from '../Shape2/Shape2';
import { StyledLink, StyledLinkTheme } from '../StyledLink/StyledLink';

import './Collapser.css';

interface CollapserItem {
    title: string;
    key: string;
    content: JSX.Element;
    expended?: Boolean;
}

interface CollapserProps {
    cls?: string;
    items: Array<CollapserItem>;
}

export class Collapser extends React.PureComponent<CollapserProps> {
    render() {
        const { cls, items } = this.props;

        return (
            <Accordion accordion={false} className={classNames('collapser', cls)}>
                {items.map(({ key, content, title, expended }) => {
                    return (
                        <AccordionItem
                            key={key}
                            uuid={key}
                            expanded={Boolean(expended)}
                            className={Bem.cls('collapser', 'item')}
                        >
                            <AccordionItemTitle className={Bem.cls('collapser', 'item-title')}>
                                <StyledLink theme={StyledLinkTheme.blue} cls={Bem.cls('collapser', 'item-title-link')}>
                                    <Shape2
                                        width={12}
                                        height={12}
                                        tone={Shape2Tone.clear}
                                        icon={Shape2Icon.verticalArrow}
                                        cls={Bem.cls('collapser', 'item-title-icon')}
                                    />
                                    {title}
                                </StyledLink>
                            </AccordionItemTitle>

                            <AccordionItemBody
                                className={Bem.cls('collapser', 'item-body')}
                                hideBodyClassName={Bem.cls({
                                    block: 'collapser',
                                    elem: 'item-body',
                                    mods: { hidden: true }
                                })}
                            >
                                {content}
                            </AccordionItemBody>
                        </AccordionItem>
                    );
                })}
            </Accordion>
        );
    }
}
